/**
 * @ngdoc config
 * @name routeProviderConfig
 * @description
 * Sets the routes for the Profile section:
 * - The default one (`/`).
 *
 * @param {Service} $routeProvider The interface for the Angular router.
 * @memberof profile
 */
const routeProviderConfig = ($routeProvider) => {
  'ngInject';

  $routeProvider
  .when('/profile', {
    template: '<profile></profile>',
  });
};

export default routeProviderConfig;



// WEBPACK FOOTER //
// ./src/frontend/modules/profile/configs/routeProvider.config.js